import { ChainType } from "@0xsquid/squid-types";
import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { IStellarContextData } from "../../core/providers/StellarProvider";
import { ConnectWalletResult, StellarWallet } from "../../core/types/wallet";
import { useWalletStore } from "../store/useWalletStore";
import { useStellarWallets } from "./useStellarWallets";

export function useStellar(): IStellarContextData {
  const { wallets } = useStellarWallets();
  const connectedStellarWallet = useWalletStore(
    (store) => store.connectedWalletsByChainType[ChainType.STELLAR]
  );

  const connectStellar = useMutation(
    async ({
      wallet,
    }: {
      wallet: StellarWallet;
    }): Promise<ConnectWalletResult<ChainType.STELLAR>> => {
      const { address } = await wallet.connector.getAddress();

      return {
        wallet,
        address,
      };
    }
  );

  const disconnectStellar = useCallback(async () => {
    await connectedStellarWallet.wallet?.connector.disconnect?.();
  }, [connectedStellarWallet.wallet?.connector]);

  return {
    connectStellar,
    disconnectStellar,
    signer: connectedStellarWallet.wallet?.connector,
    wallets,
  };
}
